export default "__VITE_ASSET__C5ZEorcr__"